import type { BaseCourseDto } from './models';
import { RestService } from '@abp/ng.core';
import type { ListResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CoursesLookupService {
  apiName = 'Default';
  

  getCourseLookup = () =>
    this.restService.request<any, ListResultDto<BaseCourseDto>>({
      method: 'GET',
      url: '/api/app/courses-lookup/course-lookup',
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
